/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import {
  Directive,
  ElementRef,
  Renderer2,
  OnDestroy,
  ContentChildren,
  QueryList,
  Input,
} from '@angular/core';
import { XrxInputComponent } from '../components/controls/xrx-input.component';

@Directive({
  selector: '[input-tab]',
  standalone: false,
})
export class InputTabDirective implements OnDestroy {
  @Input() ignoreSubmit = false;
  @ContentChildren(XrxInputComponent, { descendants: true })
  children: QueryList<XrxInputComponent>;

  listener: () => void;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {
    this.listener = this.renderer.listen(
      this.elementRef.nativeElement,
      'keypress',
      (event) => {
        if (event.keyCode === 13) {
          this.handleEnterKey(event);
        }
      },
    );
  }

  handleEnterKey(e: KeyboardEvent) {
    let focusedIndex = -1;
    const focusedInput = document.activeElement as HTMLElement;
    if (focusedInput) {
      this.children.find((ele, idx) => {
        if (ele.id === focusedInput.id) {
          focusedIndex = idx;
          return true;
        }
        return false;
      });

      if (focusedIndex > -1) {
        setTimeout(() => {
          if (focusedInput.className.indexOf('is-invalid') != -1) {
            focusedInput.focus();
            e.preventDefault();
          }
        });
        if (focusedInput.className.indexOf('is-invalid') != -1) {
          e.preventDefault();
        } else if (focusedIndex < this.children.length - 1) {
          this.children.forEach((ele, idx) => {
            if (idx === focusedIndex + 1) {
              ele.focus();
              return;
            }
          });
          e.preventDefault();
        } else {
          //submit
          focusedInput.blur();
          if (this.ignoreSubmit) {
            e.preventDefault();
          }
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.listener();
  }
}
